<template>
    <div class="my-jobs-garden-help">
        <b-card no-body class="card-transparent-background mt-3 mb-0 p-0">
            <b-card-header class="px-0">
                <b-card-title class="card-title-page-garden-help-default my-1">
                    {{ type == 'requests' ? 'Requests' : 'My Quotes' }}
                </b-card-title>
            </b-card-header>
        </b-card>
        <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm" style="min-height:100%">
            <b-card no-body>
                <b-card-header>
                    <b-row>
                        <b-col xl="6" lg="8" md="9">
                            <b-input-group class="input-group-search input-group-search-garden-help">
                                <template #prepend>
                                    <font-awesome-icon icon="fa-solid fa-magnifying-glass" size="lg" />
                                </template> <b-form-input v-model="search" class="form-control-garden-help"
                                    placeholder="Search "></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>
                </b-card-header>
                <b-card-body class="px-0">
                    <b-table-simple class="gardenHelpTable" responsive stacked="md">
                        <b-thead>
                            <b-tr>
                                <b-th class="text-center">Created At</b-th>
                                <b-th>Job No.</b-th>
                                <b-th>Quote No.</b-th>
                                <b-th>Customer Name</b-th>
                                <b-th>Services</b-th>
                                <b-th class="text-center">Total</b-th>
                                <b-th>Status</b-th>
                                <b-th></b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody v-if="quotes.length > 0">
                            <b-tr v-for="(quote, index) in quotes" :key="index"
                                @click="clickViewQuote($event, quote.id, quote.model.id)">
                                <b-td stacked-heading="Created At" class="text-center">
                                    <p class="dateTdSpan">{{ quote.created_at.substring(0, 9) }}</p>
                                    <p>{{ quote.created_at.substring(10) }}</p>
                                </b-td>
                                <b-td stacked-heading="Job No.">{{ quote.model != null ? quote.model.order_id : "" }}</b-td>
                                <b-td stacked-heading="Quote No.">{{ quote.invoice_number }}</b-td>
                                <b-td stacked-heading="Customer Name">{{ quote.model.contact == null ? '' :
                                    quote.model.contact.name
                                }}</b-td>
                                <b-td stacked-heading="Services" class="serviceTd"
                                    v-html="getServicesNamesFromObject(quote.items)"></b-td>
                                <!-- <b-td stacked-heading="Services" class="serviceTd"></b-td> -->
                                <b-td stacked-heading="Total" class="text-center">
                                    {{ quote.total }} {{ quote.currency }}
                                </b-td>
                                <b-td stacked-heading="Job Status" class="text-center">
                                    <span
                                        :class="'quoteStatusSpan ' + quote.status + (quote.paid == true ? '_paid' : '') + '_status'">
                                        {{ quote.status == 'quote_rejected' ? 'Quote rejected' :
                                            quote.status }} {{ quote.paid == true ? ' Paid' : '' }}</span>

                                </b-td>
                                <b-td class="text-center">
                                    <b-button
                                        v-if="quote.status == 'invoice' && quote.model.status === 'complete' && quote.paid == false"
                                        :id="'btn_send_quote_' + quote.id" variant="garden-help-primary-link" size="lg"
                                        class="btn-bumblebee btn-garden-help p-0 h-auto"
                                        @click="clickSendEmail($event, quote.id)">
                                        <font-awesome-icon icon="fa-solid fa-paper-plane" class="mr-1" />
                                    </b-button>
                                    <b-button v-else :id="'btn_send_quote_' + quote.id" variant="garden-help-primary-link"
                                        size="lg" class="btn-bumblebee btn-garden-help p-0 h-auto disabled">
                                        <font-awesome-icon icon="fa-solid fa-paper-plane" class="mr-1" />
                                    </b-button>
                                    <b-popover custom-class="popover-garden-help" :target="'btn_send_quote_' + quote.id"
                                        triggers="hover" placement="left">
                                        Send Payment Email
                                    </b-popover>
                                    <!-- <b-dropdown id="dropdown-dropleft" dropleft no-caret variant="link" toggle-class="p-0"
                                        class="dropdown-actions-garden-help m-2">
                                        <template #button-content> <img
                                                src="@/assets/images/garden-help/more-actions-icon.png" />
                                        </template>
                                        <b-dropdown-item :href="'/garden_help/quote/view/' + quote.id" class="my-1">
                                            <font-awesome-icon icon="fa-solid fa-eye" class="mr-1" />
                                            View</b-dropdown-item>
                                        <b-dropdown-item 
                                            class="my-1">
                                            <font-awesome-icon icon="fa-solid fa-paper-plane" class="mr-1" />
                                            Send Payment Email</b-dropdown-item>
                                    </b-dropdown> -->
                                </b-td>
                            </b-tr>
                        </b-tbody>
                        <b-tbody v-else>
                            <b-tr>
                                <b-td :colspan="type == 'requests' ? 7 : 8" class="text-center cursor-initial">
                                    No results found
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>

                </b-card-body>
            </b-card>
            <!-- pagination -->
            <b-card class="card-transparent-background m-0" no-body>
                <b-card-body class="px-2 py-0">
                    <b-row cols="1" cols-md="2">
                        <b-col>
                            <p class="data-list-info-garden-help">
                                Showing {{ from_page }} to {{ to_page }} of
                                {{ total_items }} entries
                            </p>
                        </b-col>
                        <b-col>
                            <b-pagination class="pagination-garden-help" v-model="currentPage" :total-rows="total_items"
                                :per-page="perPage" limit="7" @change="changePage" size="md"></b-pagination></b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-overlay>
        <!---- accept quote job ---->
        <SendPaymentEmail v-if="type == 'quotes'" :client_name="client_name" :quote_id="selected_quote_id" />
    </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";

import SendPaymentEmail from './SendPaymentURLModal.vue'


import {
    getJobStatusClassAndStr, getStatusPercentage, listServicesRequest,
    listExperienceLevels,
    listPropertyTypes, getJobStatusListForFilter, getServicesNamesFromObject
} from "@/utils/helper-functions-garden-help.js"

export default {
    name: "QuotesTable",
    components: { SendPaymentEmail },
    props: ["type"],
    data() {
        return {
            show_overlay: false,
            client_name: "GARDENHELP",
            user_type: localStorage.getItem('user_type'),
            user_id: null, // logined user

            search: "",
            quotes: [],
            // pagination
            perPage: 10,
            currentPage: 1,
            total_items: 0,
            from_page: 0,
            to_page: 0,
            // // filter data
            // servies_list: [],
            // service_filter: [],
            // experience_levels_list: [],
            // experience_level_filter: [],
            // property_types_list: [],
            // property_type_filter: [],
            // distance: 10,
            // status_list: [],
            // status_filter: []

            selected_quote_id: null,
        }
    },
    mounted() {
        let user = JSON.parse(window.localStorage.getItem("user"));
        this.user_id = user.id

        console.log(this.type)
        // this.getFilterData()

        this.getQuotesList(this.type)
    },
    watch: {
        search(newval) {
            console.log("search", this.search)
            this.getQuotesList(this.type)
        }
    },
    methods: {
        getJobStatusClassAndStr, getStatusPercentage, listServicesRequest,
        listExperienceLevels,
        listPropertyTypes, getJobStatusListForFilter,
        getServicesNamesFromObject,
        // async getFilterData() {
        //     this.experience_levels_list = listExperienceLevels();
        //     this.property_types_list = listPropertyTypes();

        //     this.servies_list = await this.listServicesRequest(null);

        //     this.status_list = this.getJobStatusListForFilter()
        // },
        getInvoiceStatus(status, paid) {
            console.log(status, paid)
            let is_paid = ''
            if (status == 'invoice') {
                is_paid = paid == true ? ' Paid' : ''
            }
            return is_paid
        },
        changePage(value) {
            console.log("change page", value);
            this.currentPage = value
            this.getQuotesList(this.type)
        },
        clickClearFilters() {
            this.service_filter = [];
            this.experience_level_filter = [];
            this.property_type_filter = [];
            this.distance = 0;
            this.status_filter = []
        },
        clickFilter() {

            console.log("click filter")
            this.currentPage = 1

            console.log("Service", this.service_filter)
            // console.log("experience", this.experience_level_filter)
            console.log("type", this.property_type_filter)
            // console.log("distance", this.distance)
            console.log("status", this.status_filter)


            console.log(this.$refs.sidebar_filter)
            this.$refs.sidebar_filter.hide()
            this.getQuotesList(this.type)
        },
        clickViewQuote(e, quote_id, job_id) {
            e.preventDefault();
            console.log(e )
            console.log(e.target )
            console.log(e.target.cellIndex )

            if (e.target.cellIndex == undefined) {
            } else {
                if (this.type == 'requests') {
                    this.$router.push({ name: "GardenHelpRequestQuoteIndex", params: { quote_id: quote_id, id: job_id } });
                } else if (this.type == 'quotes') {
                    this.$router.push({ name: "GardenHelpViewQuote", params: { id: quote_id } });
                }
            }
        },
        getQuotesList(type) {
            console.log("in get job lists", type, this.user_type, this.user_id)
            this.show_overlay = true
            console.log(this.currentPage)
            let params_request = "?per_page=" + this.perPage + "&page=" + this.currentPage;
            console.log(params_request)


            if (this.search != null && this.search != "") {
                params_request += "&keyword=" + this.search
            }


            if (type == 'requests') {
                params_request += "&status=request"
            } else if (type == 'quotes') {
                params_request += "&status=quote,invoice,quote_rejected"
            }

            console.log(params_request)

            axios
                .get("/payment/invoices" + params_request + '', {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    // console.log(response)
                    this.quotes = response.data.data;

                    this.total_items = response.data.meta.total
                    if (response.data.meta.total == 0) {
                        this.from_page = 0
                        this.to_page = 0
                    } else {
                        this.from_page = ((this.currentPage - 1) * this.perPage) + 1
                        this.to_page = this.currentPage * this.perPage > response.data.meta.total ? response.data.meta.total : this.currentPage * this.perPage
                    }
                    this.show_overlay = false

                });
        },
        clickSendEmail(e, quote_id) {
            console.log("click send payment email", quote_id)
            this.selected_quote_id = quote_id
            this.$root.$emit("bv::show::modal", "sendEmailModal");
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/quotes/QuotesTable.vue